var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.winesTogglr = function() {
	$('.toggle-in').click(function () {
		$('.mobile-wines').addClass('on');
		setTimeout(function(){
			$('.mobile-wines').addClass('visible');	
		}, 10);
		return false;
	});
	$('.toggle-out').click(function () {
		$('.mobile-wines').removeClass('visible');
		setTimeout(function(){
			$('.mobile-wines').removeClass('on');	
		}, 500);
		return false;
	});
	$('.open-nav').click(function () {
		$('.mobile-wines').removeClass('visible');
		setTimeout(function(){
			$('.mobile-wines').removeClass('on');	
		}, 500);
	});
}();

FIGURE.wineFiltr = function() {
	//Carousel Page
	$('.wines-filter a').click(function () {
		$('.wines-filter a').removeClass('selected');
		$(this).addClass('selected');
		var toShow = $(this).attr('data-category');
		$('.wines-slick').addClass('d-none');
		const minCheck = $(toShow).data('wine-count');
		$(toShow).removeClass('d-none').slick({
			infinite: minCheck >= 3,
			initialSlide: minCheck >= 2 ? 1 : 0,
			// initialSlide: minCheck / 2,
			dots: false,
			slidesToShow: minCheck > 2 ? 3 : minCheck == 2 ? 2 : 1,
			slidesToScroll: 1,
			centerMode: true,
			cssEase: 'linear',
			variableWidth: true,
			afterChange: (currentSlide) => {
				// Manually set the current slide index
				// This prevents the carousel from locking into a position
				slider.current.slickGoTo(currentSlide);
			},
			responsive: [
				{
					breakpoint: 550,
					settings: {
						// infinite: minCheck > 1,
						initialSlide: 0,
						slidesToShow: 1,
						variableWidth: false,
						centerMode: true,
						arrows: true,
					}
				}
			]
		});
		return false;
	});
	//Shop Page
	$('.wine-filter').click(function () {
		var toShow = $(this).attr('data-the-categories');
		$('.wine-filter').removeClass('selected');
		$(this).addClass('selected');
		$('.product-listing-column').addClass('d-none');
		$(toShow).removeClass('d-none');
		return false;
	});
	if ($(".page-pages-collections").length) {
		const hash = window.location.hash.substring(1);
		if (hash) {
			const wineFilter = $(".wines-filter a").filter(`[data-category=".wines-slick.${hash}"]`);
			if (wineFilter.length) {
				wineFilter.click();
			}
		}
	}
}();

FIGURE.isElementInViewport = function($element = $(), topPadding = 0, bottomPadding = 0) {
	const scrollTop = $(window).scrollTop();
	const elementTop = $element.offset().top;
	const elementBottom = elementTop + $element.outerHeight();
	const windowHeight = $(window).height();
	// console.log("scrollTop <= elementTop - topPadding", scrollTop <= elementTop - topPadding, elementTop - topPadding, {scrollTop, topPadding, elementTop});
	// console.log("scrollTop >= -(windowHeight - (bottomPadding + elementTop))", scrollTop >= -(windowHeight - (bottomPadding + elementTop)), -(windowHeight - (bottomPadding + elementTop)), {scrollTop, bottomPadding, elementTop, windowHeight});
	return scrollTop <= elementTop - topPadding &&
		scrollTop >= -(windowHeight - (bottomPadding + elementTop));
}

FIGURE.padding = 50;
FIGURE.carouselHeight = 278

FIGURE.slick = function() {
	$('.home-slick').slick({
		infinite: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 6000,
		centerMode: true,
		cssEase: 'linear',
		variableWidth: true,
		draggable: false,
		pauseOnHover: false,
		pauseOnFocus: false,
	});
	$('.wines-slick.all').slick({
		infinite: true,
		dots: false,
		centerMode: true,
		cssEase: 'linear',
		variableWidth: true,
		initialSlide: 1,
		afterChange: (currentSlide) => {
			// Manually set the current slide index
			// This prevents the carousel from locking into a position
			slider.current.slickGoTo(currentSlide);
		},
		responsive: [
			{
				breakpoint: 550,
				settings: {
					initialSlide: 0,
					slidesToShow: 1,
					variableWidth: false,
					centerMode: true,
					arrows: true,
				}
			}
		]
	});
	$('.timeline-slick').slick({
		infinite: false,
		dots: false,
		centerMode: false,
		cssEase: 'linear',
		variableWidth: true,
		draggable: true,
		swipeToSlide: true,
		touchThreshold: 10,
		afterChange: (currentSlide) => {
			// Manually set the current slide index
			// This prevents the carousel from locking into a position
			slider.current.slickGoTo(currentSlide);
		},
		responsive: [
			{
				breakpoint: 550,
				settings: {
					slidesToShow: 1,
					variableWidth: false,
					centerMode: true,
					arrows: true,
				}
			}
		]
	});
	$(".vineyards-slick").slick({
		infinite: true,
		dots: false,
		arrows: true,
		centerMode: false,
		cssEase: 'linear',
		variableWidth: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					variableWidth: false,
					centerMode: false,
					arrows: true,
				}
			}
		]
	});
	$(".vineyards-slick").on("afterChange", function (event, slick, currentSlide) {
		const vineyardCard = $(".vineyards-slick .slick-slide.slick-active").find(".slick-vineyard-card");
		const parentKey = vineyardCard.data("key");
		$(".map-dot").removeClass("active");
		let $dot = $(".map-dot").filter(`[data-slide="${currentSlide}"]`);
		if (Array.from($(".map-dot")).some((dot) => $(dot).data("slide") == currentSlide)) {
			$(".map-dot").each((i, dot) => {
				if ($(dot).data("slide") == currentSlide) {
					$(dot).addClass("active");
				}
			});
		} else if (Array.from($(".map-dot")).some((dot) => $(dot).data("slide") == parentKey)) {
			$dot = $(".map-dot").filter(`[data-slide="${parentKey}"]`);
			$(".map-dot").each((i, dot) => {
				if ($(dot).data("slide") == parentKey) {
					$(dot).addClass("active");
				}
			});
		}
		if ($(window).width() > 767.98) {
			$dot.each((i, dot) => {
				if ($(dot).hasClass("map-dot-desktop")) {
					const divider = $(dot).closest(".map-dot-group").hasClass("dropup") ? 1.5 : 3;
					const middle = ($(window).height() - FIGURE.carouselHeight) / divider;
					const elementTop = $(dot).offset().top - middle;
					$('html, body').animate({scrollTop: elementTop}, 600); // Animate the scroll to bring the element to the specified position
				}
			})
		}
	});
	$(".map-dot-finder").on("click", function (e) {
		e.preventDefault();
		var slideIndex = $(this).data("slide");
		$(".vineyards-slick").slick("slickGoTo", slideIndex);
		if ($(window).width() > 767.98 && $(this).hasClass("map-dot-carousel")) {
			$(".map-dot-desktop").each((i, dot) => {
				const $dot = $(dot);
				const $container = $(".map-container");
				if ($dot.data("slide") == slideIndex) {
					const divider = $dot.closest(".map-dot-group").hasClass("dropup") ? 1.5 : 3;
					const middle = ($(window).height() - FIGURE.carouselHeight) / divider;
					const elementTop = $dot.offset().top - middle;
					$('html, body').animate({scrollTop: elementTop}, 600); // Animate the scroll to bring the element to the specified position
					setTimeout(() => {
						$(".desktop-map-overflow-arrow").animate({opacity: 0}, 500, () => {
							$(".desktop-map-overflow-arrow").css({display: 'none'});
						});
					}, 600);
				}
			});
		}
	});
	$(window).on("scroll load", function () {
		const mapDotGroup = $(".map-dot-group.show");
		const dropUp = mapDotGroup.filter(".dropup");
		if (dropUp.length) {
			const dropDown = dropUp.find(".map-dropdown-menu-desktop");
			if (dropDown.attr("x-placement") === "bottom-start") {
				dropDown.addClass("bottom-start");
			} else if (dropDown.attr("x-placement") === "top-start") {
				dropDown.removeClass("bottom-start");
			}
		} else if (mapDotGroup.length && !mapDotGroup.hasClass("dropup")) {
			console.log("mapDotGroup - no dropup", mapDotGroup);
			const dropDown = mapDotGroup.find(".map-dropdown-menu-desktop");
			if (dropDown.attr("x-placement") === "bottom-start") {
				dropDown.removeClass("top-start");
			} else if (dropDown.attr("x-placement") === "top-start") {
				dropDown.addClass("top-start");
			}
		}
	});
	if ($(".page-pages-vineyards").length) {
		// Create progress bar
		let progress = 0;
		const progressInterval = setInterval(function() {
			progress += Math.random() * 10;
			if (progress > 85) {
				clearInterval(progressInterval);
			}
			$('#progressBar').width(progress + '%');
		}, 500);

		$(window).on('load', function() {
			clearInterval(progressInterval);
			$('#progressBar').width('100%');

			setTimeout(function() {
				$('#loadingOverlay').fadeOut(300);
			}, 500);
		});
	}
}();

FIGURE.mapScrollIndicator = function() {
	$(window).on('resize load', function() {
		if ($(window).width() > 767.98 && $(".map-dot.active").length && $(".desktop-map-overflow-arrow").length) {
			if ($(window).scrollTop() === 0 || !FIGURE.isElementInViewport($(".map-dot.active"), FIGURE.padding, FIGURE.carouselHeight)) {
				$(".desktop-map-overflow-arrow").animate({opacity: 1}, 300);
			}
			$(window).scroll(function () {
				if(FIGURE.isElementInViewport($(".map-dot.active"), FIGURE.padding, FIGURE.carouselHeight)) {
					$(".desktop-map-overflow-arrow").fadeOut('slow');
				}
			});
		}
		$(document).on('click', '.map-dropdown-menu', function (e) {
			e.stopPropagation();
		});
	})
}();

FIGURE.videoPlay = function() {
	setTimeout(function(){
		var vid = document.getElementById("wineVideo");
		if (vid) {
			$('.vid-time').html(new Date(vid.duration * 1000).toISOString().substring(14, 19));
		}
	}, 500);
	$(document).on('click','.video-play',function(){
		var playerID = "wineVideo";
		var x = document.getElementById(playerID); 
		if($(this).hasClass('playing')) {
			x.pause();
			$(this).removeClass('playing');
			$(x).attr('controls', false);
		} else {
			x.play();	
			$(this).addClass('playing');
			$(x).attr('controls', true);
		}
		return false;
	});
}();
// FIGURE.hoverCol = function() {
// 	if ($(".page-pages-about").length) {
// 		$(".hover-col").css({transition: "all 0.5s ease"});
// 		$(".hover-col").hover(function() {
// 			if ($(this).hasClass("col-md-3")) {
// 				$(this).addClass("col-md-4");
// 				$(this).removeClass("col-md-3");
// 			} else if ($(this).hasClass("col-md-5")) {
// 				$(this).addClass("col-md-6");
// 				$(this).removeClass("col-md-5");
// 			}
// 		}, function() {
// 			if ($(this).hasClass("col-md-4")) {
// 				$(this).addClass("col-md-3");
// 				$(this).removeClass("col-md-4");
// 			} else if ($(this).hasClass("col-md-6")) {
// 				$(this).addClass("col-md-5");
// 				$(this).removeClass("col-md-6");
// 			}
// 		});
// 	}
// }();